import React, { useState } from 'react';
import './Blog1.css'
import fahim from '../../images/blog-image/fahim.jpg'
import { BsFacebook, BsLinkedin, BsInstagram, BsGithub, BsFileEarmarkPdf } from 'react-icons/bs';
import { FaXTwitter } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import npm1 from '../../images/blog-image/npm1.jpeg'
import visa from '../../images/blog-image/visa.jpg'
import program from '../../images/blog-image/study-program.jpg'
import useTitle from '../../Hooks/useTitle';
import studyAbroad from '../../images/blog-image/study-abroad.jpg'
import resume from '../../images/blog-image/resume.png'


import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/default-highlight';
import { nightOwl } from 'react-syntax-highlighter/dist/cjs/styles/hljs';
import { sunburst } from 'react-syntax-highlighter/dist/cjs/styles/hljs';
import copy from 'clipboard-copy';






import ReactPrint from 'react-to-print';
import { useRef } from 'react';










import {
    TwitterShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
    TwitterIcon,
    FacebookIcon,
    LinkedinIcon,
    WhatsappIcon,
} from "react-share";








import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import { useLanguage } from '../../context/LanguageContext';
SwiperCore.use([Autoplay, Pagination]);






















const Blog1Details = () => {


    const shareUrl = window.location.href



    // console.log('Current Window Location: ', window.location)
    // console.log('Current Page URL: ', window.location.href)
    // console.log('Path Name: ', window.location.pathname)


    const ref = useRef();


    // window.scrollTo(0, 0);
    useTitle('Blog-7 Most Popular Animation Libraries For React');

    const codeString1 = `${`
    import { useState } from "react";
    import { motion } from "framer-motion";
    import "./framer-motion.css";

    function FramerMotion() {
        const [isActive, setIsActive] = useState(false);
        return (
        <motion.div
            className="box"
            onClick={() => setIsActive(!isActive)}
            animate={{
            rotate: isActive ? [0, 90, 180, 270] : [270, 180, 90, 0], 
            borderRadius: isActive ? [0, 20, 50] : [50, 20, 0],
            }}
        ></motion.div>
        );
    }
    export default FramerMotion;
`}`
    const [copySuccess1, setCopySuccess1] = useState(false);
    const handleCopyClick1 = async () => {
        try {
            await copy(codeString1);
            setCopySuccess1(true);
            setTimeout(() => setCopySuccess1(false), 2000);
        } catch (error) {
            console.error('Copy Failed', error);
        }
    };









    const codeString2 = `${`
    import { useSpring, animated } from "@react-spring/web";
    import { useState } from "react";
    function ReactSpring() {
    const [state, toggle] = useState(true);
    const { x } = useSpring({
    from: { x: 0 }, 
    x: state ? 1 : 0, 
    config: { duration: 1000 }, 
    });
    return (
    <div onClick={() => toggle(!state)}>
        <animated.div
        style={{
            opacity: x.to({ range: [0, 1], output: [0.3, 1] }),
            transform: x
            .to({
                range: [0, 0.25, 0.35, 0.45, 0.55, 0.65, 0.75, 1],
                output: [1, 0.97, 0.9, 1.1, 0.9, 1.1, 1.03, 1],
            })
            .to((x) => 'scale(x)'),
        }}
    >
        Hello React Spring
    </animated.div>
    </div>
);
}
    export default ReactSpring;
`}`
    const [copySuccess2, setCopySuccess2] = useState(false);
    const handleCopyClick2 = async () => {
        try {
            await copy(codeString2);
            setCopySuccess2(true);
            setTimeout(() => setCopySuccess2(false), 2000);
        } catch (error) {
            console.error('Copy Failed', error);
        }
    };












    const codeString3 = `${`
    import { useState, useEffect } from "react";
    import { Animate } from "react-move";
    import "./AnimatedBars.css"; // Import the CSS file with the styles
    const colors = ["#236997", "#52aaeb", "#a75e07", "#f4a22d", "#f95b3aff"];
    const data = [10, 26, 18, 14, 32];
    function AnimatedBars() {
    const [index, setIndex] = useState(0);
    useEffect(() => {
    const intervalId = setInterval(() => {
        setIndex((prevIndex) => (prevIndex + 1) % data.length);
    }, 2000);
    return () => {
        clearInterval(intervalId);
    };
    }, []);
    return (
    <div className="App">
        <svg version="1.1" viewBox="0 0 240 135" width="100vw">
        <g>
            {data.map((value, i) => (
            <Animate
                key={i}
                start={{ height: 0 }}
                enter={{ height: [value], timing: { duration: 500 } }}
                update={{
                height: [data[(i + index) % data.length]],
                timing: { duration: 500 },
                }}
            >
                {(state) => (
                <rect
                x={60 + 30 * i} 
                y={115 - state.height} 
                width={24}
                height={state.height}
                fill={colors[i % colors.length]}
                />
                )}
            </Animate>
            ))}
        </g>
        </svg>
    </div>
    );
}
    export default AnimatedBars;
`}`
    const [copySuccess3, setCopySuccess3] = useState(false);
    const handleCopyClick3 = async () => {
        try {
            await copy(codeString3);
            setCopySuccess3(true);
            setTimeout(() => setCopySuccess3(false), 2000);
        } catch (error) {
            console.error('Copy Failed', error);
        }
    };






    const codeString4 = `${`
    import { useVideoConfig } from "remotion";

    export const MyVideo = () => {
    const { fps, durationInFrames, width, height } = useVideoConfig();
    const opacity =frame >= 30 ? 1 : frame / 30; 

    return (
    <div
        style={{
        flex: 1,
        textAlign: "center",
        fontSize: "9em",
        opacity: opacity,
        }}
        >
        This {width}px x {height}px video is {durationInFrames / fps} seconds long.
        </div>
    );
};
`}`
    const [copySuccess4, setCopySuccess4] = useState(false);
    const handleCopyClick4 = async () => {
        try {
            await copy(codeString4);
            setCopySuccess4(true);
            setTimeout(() => setCopySuccess4(false), 2000);
        } catch (error) {
            console.error('Copy Failed', error);
        }
    };





    const codeString5 = `${`
    import { Bounce, Slide } from "react-reveal";
    import Shake from "react-reveal/Shake";
    import RubberBand from "react-reveal/RubberBand";
    function ReactReveal() {
    return (
        <>
        <Bounce left>
        <h1>Bounce</h1>
        </Bounce>
        <Slide left>
        <h1>Slide</h1>
        </Slide>
        <Shake>
        <h1>Shake</h1>
        </Shake>
        <RubberBand>
        <h1>Rubberband</h1>
        </RubberBand>
    </>
    );
}
export default ReactReveal;
`}`
    const [copySuccess5, setCopySuccess5] = useState(false);
    const handleCopyClick5 = async () => {
        try {
            await copy(codeString5);
            setCopySuccess5(true);
            setTimeout(() => setCopySuccess5(false), 2000);
        } catch (error) {
            console.error('Copy Failed', error);
        }
    };







    const codeString6 = `${`
    import { useEffect, useRef } from "react";
    import anime from "animejs";
    function Anime() {
    const circleRef = useRef(null);
    const animateCircle = () => {
    const circle = circleRef.current;
    anime({
    targets: circle,
      cx: anime.random(10, 500), // Random x position between 10 and 500
      cy: anime.random(10, 500), // Random y position between 10 and 500
      duration: 2000, // Animation duration in milliseconds
      easing: "easeInOutQuad", // Easing function for smooth animation
      complete: animateCircle, // Repeat the animation infinitely
    });
    ;
    useEffect(() => {
    animateCircle();
    }, []);
    return (
    <svg width="500" height="500">
        <circle ref={circleRef} r="30" fill="blue" />
    </svg>
    );
}
export default Anime;
`}`
    const [copySuccess6, setCopySuccess6] = useState(false);
    const handleCopyClick6 = async () => {
        try {
            await copy(codeString6);
            setCopySuccess6(true);
            setTimeout(() => setCopySuccess6(false), 2000);
        } catch (error) {
            console.error('Copy Failed', error);
        }
    };



    const codeString7 = `${`
    import { useLayoutEffect, useRef } from 'react';
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/ScrollTrigger';
    gsap.registerPlugin(ScrollTrigger);
    export default function Scroll() {
    const main = useRef();
    useLayoutEffect(() => {
    const ctx = gsap.context((self) => {
        const boxes = self.selector('.box');
        gsap.from(boxes, {
        x: -500, 
        opacity: 0,
        duration: 1,
        stagger: 0.2, 
        scrollTrigger: {
            trigger: main.current,
            start: 'top 80%', 
            end: 'bottom 20%', 
            scrub: true,
        },
        });
    }, main); 
    return () => ctx.revert(); 
    }, []);
    return (
    <div>
        <section className="section flex-center column">
        <h2>Scroll down to see the animation!!</h2>
        </section>
        <div className="section flex-center column" ref={main}>
        <div className="box">Box 1</div>
        <div className="box">Box 2</div>
        <div className="box">Box 3</div>
        <div className="box">Box 4</div>
        <div className="box">Box 5</div>
        </div>
        <section className="section"></section>
    </div>
    );
}
`}`
    const [copySuccess7, setCopySuccess7] = useState(false);
    const handleCopyClick7 = async () => {
        try {
            await copy(codeString7);
            setCopySuccess7(true);
            setTimeout(() => setCopySuccess7(false), 2000);
        } catch (error) {
            console.error('Copy Failed', error);
        }
    };








    const postUrl = `https://fahim-faysal-portfolio.netlify.app/blog1`;
    const postTitle = 'Popular Animation Libraries For React';
    const shareOnTwitter = () => {
        window.open(`https://twitter.com/intent/tweet?text=${postTitle}&url=${postUrl}`, '_blank');
    };
    const shareOnFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${postUrl}`, '_blank');
    };
    const shareOnLinkedIn = () => {
        window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${postUrl}&title=${postTitle}`, '_blank');
    };
    <Helmet>
        <title>{postTitle}</title>
        <meta property="og:title" content={postTitle} />
        <meta property="og:image" content={visa} />
        <meta property="og:url" content={`https://fahim-faysal-portfolio.netlify.app/blog1`} />
    </Helmet>









    const { language } = useLanguage()












    return (
        <div className=' mt-12 lg:px-2 md:px-2 px-0 '>


            <div className='flex justify-center lg:flex-row flex-col mb-20 lg:px-0 md:px-8 px-2 lg:gap-x-2 lg:gap-y-0 gap-x-4 gap-y-20'>



                <div className='fixed print:hidden lg:block hidden lg:w-3/12 w-full mx-auto lg:px-4 px-1 md:left-0 top-[160px]'>
                    <div className=''>
                        <div className={`bg-base-100 border-r-4 border-gray-600   rounded-lg }`}>
                            <div className="avatar flex justify-center items-center">
                                <div className="mt-2  w-[105px] rounded-full">
                                    <img className='mx-auto' src={fahim} alt='fahim' />
                                </div>
                            </div>
                            <p className='-mt-1 text-white text-2xl font-bold text-center px-6 py-3'>FAHIM FAYSAL</p>
                            <p className='-mt-1 text-[16px] text-justify px-4'>I am a full-stack developer from Bangladesh and am available to work in office or remotely.</p>
                            <p className='mt-3 text-[16px] text-amber-500 text-justify px-4'>Expert In: <span className='text-white'>ReactJS, NodeJS, MongoDB, Redux, Firebase</span></p>
                            <div className='flex justify-center items-center gap-x-4 mt-4'>
                                <div className=''>
                                    <a href='https://github.com/Fahimsakib1?tab=repositories' target='blank' className='tooltip' data-tip='GitHub'>
                                        <BsGithub className='text-white text-2xl my-2 hover:bg-black hover:text-white rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsGithub>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.linkedin.com/in/fahim-faysal/' target='blank' className='tooltip' data-tip='LinkedIn'>
                                        <BsLinkedin className='text-white text-2xl my-2 hover:text-blue-700 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsLinkedin>
                                    </a>
                                </div>
                                <div className=' '>
                                    <a href='https://www.instagram.com/i_fahiim/' target='blank' className='tooltip' data-tip='Instagram'>
                                        <BsInstagram className='text-white text-2xl my-2 hover:text-rose-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsInstagram>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.facebook.com/fahim.sakib.5' target='blank' className='tooltip' data-tip='Facebook'>
                                        <BsFacebook className='text-white text-2xl my-2 hover:text-blue-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsFacebook>
                                    </a>
                                </div>
                            </div>
                            <Link to='/contact'>
                                <div className='w-full mt-3 mx-auto text-center cursor-pointer'>
                                    <button className=' text-lg w-full px-16 py-2 bg-rose-700 hover:bg-rose-800 rounded-sm text-white'>Hire Me</button>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>



                <div className='lg:ml-[355px] lg:w-6/12 w-full mx-auto bg-white screen:shadow-2xl print:shadow-none md:px-6 px-2 py-8 ml-0'>

                    <div ref={ref} className='bg-white text-black mt-6'>

                        {
                            language === 'english' ?
                                <div>
                                    <h2 className='font-sans lg:text-4xl md:text-4xl text-[29px] text-justify font-bold text-black mb-3'>7 Most Popular Animation Libraries For React</h2>

                                    <p className='mt-8 text-justify px-2 text-gray-800 font-serif  text-[19px]'> For a React frontend developer, implementing animations on webpages is an integral part of your daily work, from animating text or images to complex 3D animations. Animation can help improve the overall user experience of a React application.</p>
                                    <p className='mt-3 text-justify px-2 text-gray-800 font-serif text-[19px]'> In this blog, I will describe the top 7 React animation libraries and evaluate each for popularity, readability, documentation to help you choose the right library for your React project.</p>
                                </div>
                                :
                                <div>
                                    <h2 className='font-sans lg:text-[32px] md:text-[32px] text-[24px] text-justify font-bold text-black mb-3 leading-snug'>রিঅ্যাক্ট এর জন্য 7টি সর্বাধিক জনপ্রিয় অ্যানিমেশন লাইব্রেরি</h2>
                                    <p className='mt-8 text-justify px-2 text-gray-800 font-serif  text-[19px]'> রিঅ্যাক্ট ফ্রন্টএন্ড ডেভেলপারের জন্য, ওয়েবপেজে অ্যানিমেশন প্রয়োগ করা আপনার দৈনন্দিন কাজের একটি অবিচ্ছেদ্য অংশ, টেক্সট বা ছবি অ্যানিমেটিং থেকে শুরু করে জটিল 3D অ্যানিমেশন পর্যন্ত। অ্যানিমেশন একটি প্রতিক্রিয়া অ্যাপ্লিকেশনের সামগ্রিক ব্যবহারকারীর অভিজ্ঞতা উন্নত করতে সাহায্য করতে পারে।</p>
                                    <p className='mt-3 text-justify px-2 text-gray-800 font-serif text-[19px]'> এই ব্লগে, আমি সেরা 7 টি রিঅ্যাক্ট এর অ্যানিমেশন লাইব্রেরি বর্ণনা করব এবং আপনার রিঅ্যাক্ট প্রকল্পের জন্য সঠিক লাইব্রেরি বেছে নিতে সাহায্য করার জন্য জনপ্রিয়তা, পঠনযোগ্যতা এবং ডকুমেন্টেশনের জন্য প্রতিটির মূল্যায়ন করব।</p>
                                </div>
                        }




                        {/* 1st Animation Package */}
                        <div>

                            {
                                language === 'english' ?
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>1. Framer Motion</h1>
                                    :
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>1. Framer Motion (ফ্রেমার মোশন)</h1>
                            }

                            {
                                language === 'english' ?
                                    <div>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>Framer Motion is a popular React animation library that makes creating animations easy. It boasts a simplified API that abstracts the complexities behind animations and allows developers to create animations with ease. Even better, it has support for server-side rendering, gestures, and CSS variables.</p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>To install Framer Motion, run one of the following two commands in your terminal based on which package you are using:</p>
                                    </div>
                                    :
                                    <>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>ফ্রেমার মোশন হল একটি জনপ্রিয় রিঅ্যাক্ট অ্যানিমেশন লাইব্রেরি যা অ্যানিমেশন তৈরি করা সহজ করে তোলে। এটি একটি সরলীকৃত API নিয়ে গর্ব করে যা অ্যানিমেশনের পিছনের জটিলতাগুলিকে বিমূর্ত করে এবং বিকাশকারীদের সহজে অ্যানিমেশন তৈরি করতে দেয়৷ আরও ভাল, এটি সার্ভার-সাইড রেন্ডারিং, অঙ্গভঙ্গি এবং CSS ভেরিয়েবলগুলির জন্য সমর্থন করে।</p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>ফ্রেমার মোশন ইনস্টল করতে, আপনি কোন প্যাকেজটি ব্যবহার করছেন তার উপর ভিত্তি করে আপনার টার্মিনালে নিম্নলিখিত দুটি কমান্ডের একটি চালান:</p>
                                    </>
                            }

                            <p className='mt-5 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>npm install framer-motion</p>
                            <p className='mt-4 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>yarn add framer-motion</p>

                            {
                                language === 'english' ?
                                    <p className='mt-4 text-black text-[17px]'>Next, add the following code block to add cool yet simple animation to a square-shaped element:</p>
                                    :
                                    <p className='mt-4 text-black text-[17px]'>এর পরে, অ্যানিমেশন যোগ করতে নিম্নলিখিত কোড ব্লক যুক্ত করুন:</p>
                            }

                            <div className='mt-8'>
                                <div className='rounded-lg shadow-lg relative'>
                                    <button
                                        onClick={handleCopyClick1}
                                        className="absolute top-3 right-2 px-3 py-1 bg-gray-700 hover:bg-gray-600 text-white rounded cursor-pointer"
                                    >
                                        {copySuccess1 ? 'Copied!' : 'Copy'}
                                    </button>
                                    <SyntaxHighlighter language="javascript" style={sunburst}>
                                        {codeString1}
                                    </SyntaxHighlighter>
                                </div>
                            </div>


                            {
                                language === 'english' ?
                                    <div>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>Framer Motion Advantages</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ Framer Motion has a developer-friendly API and comes with declarative syntax making it simple to define animations</li>
                                            <li className='text-justify mb-3'>⦿ Hardware-accelerated animations resulting in smooth animations even on less powerful devices</li>
                                            <li className='text-justify mb-3'>⦿ The library offers a wide range of animations, including basic animations (e.g., opacity, scale) and more advanced ones like physics-based animations and keyframes</li>
                                            <li className='text-justify mb-3'>⦿ The library aims to be accessible by default. It takes into consideration factors like reducedMotion, which can scale down or entirely disable motion, making the experience more accessible for users who may be sensitive to motion</li>
                                            <li className='text-justify mb-3'>⦿ Uses LazyMotion to reduce bundle size by synchronously or asynchronously loading some, or all, of the motion component’s features</li>
                                            <li className='text-justify mb-3'>⦿ <span className='text-blue-700 hover:underline cursor-pointer'><a href='https://www.framer.com/motion/?utm_source=motion-readme-docs' alt='documentation' target='blank'>Well-documented</a></span> with examples and available to support the community via <span className='text-blue-700 hover:underline cursor-pointer'><a href='https://github.com/framer/motion' alt='GitHub' target='blank'>GutHub</a></span>, <span className='text-blue-700 hover:underline cursor-pointer'><a href='https://twitter.com/framer/' target='blank'>Twitter</a></span>, and <span className='text-blue-700 hover:underline cursor-pointer'><a href='https://discord.com/servers/framer-341919693348536320' target='blank'>Discord</a></span></li>
                                        </ul>
                                    </div>
                                    :
                                    <div>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>ফ্রেমার মোশনের সুবিধা</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ ফ্রেমার মোশনের একটি Deeveloper বান্ধব API রয়েছে এবং এটি অ্যানিমেশনগুলিকে সংজ্ঞায়িত করা সহজ করে তোলে ঘোষণামূলক সিনট্যাক্স সহ আসে</li>
                                            <li className='text-justify mb-3'>⦿ হার্ডওয়্যার-এক্সিলারেটেড অ্যানিমেশনের ফলে কম শক্তিশালী ডিভাইসেও মসৃণ অ্যানিমেশন তৈরি হয়</li>
                                            <li className='text-justify mb-3'>⦿ এই লাইব্রেরিটি মৌলিক অ্যানিমেশন (যেমন: opacity, scale) এবং পদার্থবিদ্যা-ভিত্তিক অ্যানিমেশন এবং কীফ্রেমের মতো আরও উন্নত অ্যানিমেশন সহ বিস্তৃত অ্যানিমেশন অফার করে</li>
                                            <li className='text-justify mb-3'>⦿ লাইব্রেরিটি ডিফল্টরূপে অ্যাক্সেসযোগ্য হওয়ার লক্ষ্য রাখে। এটি হ্রাস গতির মতো বিষয়গুলি বিবেচনা করে, যা গতিকে স্কেল বা সম্পূর্ণরূপে অক্ষম করতে পারে, যা গতির প্রতি সংবেদনশীল ব্যবহারকারীদের জন্য অভিজ্ঞতাকে আরও অ্যাক্সেসযোগ্য করে তোলে</li>
                                            <li className='text-justify mb-3'>⦿ সিঙ্ক্রোনাস বা অ্যাসিঙ্ক্রোনাসভাবে মোশন কম্পোনেন্টের কিছু বৈশিষ্ট্য লোড করে বান্ডিলের আকার কমাতে Lazy মোশন ব্যবহার করে</li>
                                            <li className='text-justify mb-3'>⦿ <span className='text-blue-700 hover:underline cursor-pointer'><a href='https://www.framer.com/motion/?utm_source=motion-readme-docs' alt='documentation' target='blank'>তথ্যসমৃদ্ধ</a></span> উদাহরণ সহ এবং এর মাধ্যমে সম্প্রদায়কে সমর্থন করার জন্য উপলব্ধ <span className='text-blue-700 hover:underline cursor-pointer'><a href='https://github.com/framer/motion' alt='GitHub' target='blank'>GutHub</a></span>, <span className='text-blue-700 hover:underline cursor-pointer'><a href='https://twitter.com/framer/' target='blank'>Twitter</a></span>, and <span className='text-blue-700 hover:underline cursor-pointer'><a href='https://discord.com/servers/framer-341919693348536320' target='blank'>Discord</a></span></li>
                                        </ul>
                                    </div>
                            }




                        </div>


                        {/* 2nd Animation Package */}
                        <div>

                            {
                                language === 'english' ?
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>2. React Spring</h1>
                                    :
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>2. React Spring (রিঅ্যাক্ট স্প্রিং)</h1>
                            }


                            {
                                language === 'english' ?
                                    <div>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>React Spring is a modern animation library that is based on spring physics. It’s highly flexible and covers most animations needed for a user interface. Drawing inspiration from React Motion, React Spring inherits ease of use, while also borrowing some powerful performance attributes from React-Animated-CSS.</p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>To see React Spring in action, install the library by using one of the commands below based on which package you are using:</p>
                                        <p className='mt-5 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>npm install @react-spring/web</p>
                                        <p className='mt-4 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>yarn add @react-spring/web</p>
                                        <p className='mt-4 text-black text-[17px]'>Next, add the code below to create an animated Hello React Spring text:</p>
                                    </div>
                                    :
                                    <div>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>রিঅ্যাক্ট স্প্রিং হল একটি আধুনিক অ্যানিমেশন লাইব্রেরি যা স্প্রিং ফিজিক্সের উপর ভিত্তি করে। এটি অত্যন্ত নমনীয় এবং ব্যবহারকারী ইন্টারফেসের জন্য প্রয়োজনীয় বেশিরভাগ অ্যানিমেশন কভার করে। রিঅ্যাক্ট মোশন থেকে অনুপ্রেরণা নিয়ে, রিঅ্যাক্ট স্প্রিং উত্তরাধিকারসূত্রে ব্যবহারের সহজলভ্যতা লাভ করে, পাশাপাশি রিঅ্যাক্ট-অ্যানিমেটেড-সিএসএস থেকে কিছু শক্তিশালী পারফরম্যান্স বৈশিষ্ট্য ধার করে।</p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>অ্যাকশন স্প্রিং দেখতে, আপনি কোন প্যাকেজটি ব্যবহার করছেন তার উপর ভিত্তি করে নীচের একটি কমান্ড ব্যবহার করে লাইব্রেরি ইনস্টল করুন:</p>
                                        <p className='mt-5 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>npm install @react-spring/web</p>
                                        <p className='mt-4 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>yarn add @react-spring/web</p>
                                        <p className='mt-4 text-black text-[17px]'>এর পরে, একটি অ্যানিমেটেড হ্যালো রিঅ্যাক্ট স্প্রিং পাঠ্য তৈরি করতে নীচের কোডটি যোগ করুন:</p>
                                    </div>
                            }



                            <div className='mt-8 '>
                                <div className='rounded-lg shadow-lg relative'>
                                    <button
                                        onClick={handleCopyClick2}
                                        className="absolute top-3 right-2 px-3 py-1 bg-gray-700 hover:bg-gray-600 text-white rounded cursor-pointer"
                                    >
                                        {copySuccess2 ? 'Copied!' : 'Copy'}
                                    </button>
                                    <SyntaxHighlighter language="javascript" style={sunburst}>
                                        {codeString2}
                                    </SyntaxHighlighter>
                                </div>
                            </div>

                            {
                                language === 'english' ?
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>React Spring Advantages</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ React Spring has a straightforward API and integrates well with React components using hooks and functional components</li>
                                            <li className='text-justify mb-3'>⦿ Physics-based animation creates smooth animations with high frame rate</li>
                                            <li className='text-justify mb-3'>⦿ Supports interpolation, which allows us to smoothly transition values between different states</li>
                                            <li className='text-justify mb-3'>⦿  26.1k stars on GitHub and 762k weekly downloads on npm. Used by companies and startups such as Aragon, CodeSandbox, Next.js, and many others</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://www.react-spring.dev/" target='blank'>https://www.react-spring.dev/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/pmndrs/react-spring" target='blank'>https://github.com/pmndrs/react-spring</a> </li>
                                        </ul>
                                    </>
                                    :
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>রিঅ্যাক্ট স্প্রিং এর সুবিধা</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ রিঅ্যাক্ট স্প্রিং এর একটি সহজবোধ্য API রয়েছে এবং হুক এবং কার্যকরী উপাদান ব্যবহার করে প্রতিক্রিয়া উপাদানগুলির সাথে ভালভাবে সংহত করে</li>
                                            <li className='text-justify mb-3'>⦿ পদার্থবিদ্যা-ভিত্তিক অ্যানিমেশন উচ্চ ফ্রেম হার সহ মসৃণ অ্যানিমেশন তৈরি করে</li>
                                            <li className='text-justify mb-3'>⦿ ইন্টারপোলেশন সমর্থন করে, যা আমাদের বিভিন্ন রাজ্যের মধ্যে মানগুলিকে মসৃণভাবে রূপান্তর করতে দেয়</li>
                                            <li className='text-justify mb-3'>⦿  GitHub-এ 26.1k স্টার এবং npm-এ 762k সাপ্তাহিক ডাউনলোড। কোম্পানি এবং স্টার্টআপ যেমন আরাগন, কোডস্যান্ডবক্স, নেক্সট.জেএস এবং আরও অনেকের দ্বারা ব্যবহৃত</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://www.react-spring.dev/" target='blank'>https://www.react-spring.dev/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/pmndrs/react-spring" target='blank'>https://github.com/pmndrs/react-spring</a> </li>
                                        </ul>
                                    </>
                            }


                        </div>



                        {/* 3rd Animation Package */}
                        <div>
                            {
                                language === 'english' ?
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>3. React Move</h1>
                                    :
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>3. React Move (রিঅ্যাক্ট মুভ)</h1>
                            }

                            {
                                language === 'english' ?
                                    <div>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>React Move is a library designed for creating beautiful and data-driven animations by leveraging the animation capabilities of D3.js. It was designed to support TypeScript out of the box and also supports custom tweening functions. Tweening is short for “inbetweening,” the process of generating images for frame-by-frame animation between keyframes. React Move also features lifecycle events in its transitions, as well as allowing developers to pass on custom tweens in their animations. </p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>To install React Move, install the library by using one of the commands below based on which package you are using:</p>

                                    </div>
                                    :
                                    <div>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>রিঅ্যাক্ট মুভ হল একটি লাইব্রেরি যা D3.js-এর অ্যানিমেশন ক্ষমতার ব্যবহার করে সুন্দর এবং ডেটা-চালিত অ্যানিমেশন তৈরি করার জন্য ডিজাইন করা হয়েছে। এটি বাক্সের বাইরে টাইপস্ক্রিপ্ট সমর্থন করার জন্য ডিজাইন করা হয়েছিল এবং কাস্টম টুইনিং ফাংশনগুলিকেও সমর্থন করে। কিফ্রেমের মধ্যে ফ্রেম-বাই-ফ্রেম অ্যানিমেশনের জন্য ইমেজ তৈরির প্রক্রিয়া "ইনবিটভিনিং" এর জন্য টুইনিং সংক্ষিপ্ত। রিঅ্যাক্ট মুভ এর ট্রানজিশনে লাইফসাইকেল ইভেন্টগুলিও রয়েছে, সেইসাথে ডেভেলপারদের তাদের অ্যানিমেশনগুলিতে কাস্টম টুইনগুলি পাস করার অনুমতি দেয়। </p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>রিঅ্যাক্ট মুভ ইনস্টল করতে, আপনি কোন প্যাকেজটি ব্যবহার করছেন তার উপর ভিত্তি করে নীচের একটি কমান্ড ব্যবহার করে লাইব্রেরি ইনস্টল করুন:</p>

                                    </div>
                            }

                            <p className='mt-5 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>npm install react-move</p>
                            <p className='mt-4 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>yarn add react-move</p>


                            {
                                language === 'english' ?
                                    <p className='mt-4 text-black text-[17px]'>Next, add this code block to create animated bars using React Move:</p>
                                    :
                                    <p className='mt-4 text-black text-[17px]'>এর পরে, রিঅ্যাক্ট মুভ ব্যবহার করে অ্যানিমেটেড বার তৈরি করতে এই কোড ব্লক যোগ করুন:</p>
                            }


                            <div className='mt-8 overflow-y-scroll h-[600px]'>
                                <div className='rounded-lg shadow-lg relative'>
                                    <button
                                        onClick={handleCopyClick3}
                                        className="absolute top-3 right-2 px-3 py-1 bg-gray-700 hover:bg-gray-600 text-white rounded cursor-pointer"
                                    >
                                        {copySuccess3 ? 'Copied!' : 'Copy'}
                                    </button>
                                    <SyntaxHighlighter language="javascript" style={sunburst}>
                                        {codeString3}
                                    </SyntaxHighlighter>
                                </div>
                            </div>

                            {
                                language === 'english' ?
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>React Move Advantages</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ React move uses D3.js, a widely used JavaScript library for data visualization, to handle animations. D3.js provides a rich set of features for animating elements, including transitions, interpolations, and easing functions, which allows React Move to offer a rich set of animations</li>
                                            <li className='text-justify mb-3'>⦿ Offers a wide range of animation options, including positional animations, color transitions, and more. It allows you to create complex animations with ease</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://react-move-docs.netlify.app/" target='blank'>https://react-move-docs.netlify.app/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/sghall/react-move" target='blank'>https://github.com/sghall/react-move</a> </li>
                                        </ul>
                                    </>
                                    :
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>রিঅ্যাক্ট মুভ এর সুবিধা</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ রিঅ্যাক্ট মুভ অ্যানিমেশনগুলি পরিচালনা করতে D3.js, ডেটা ভিজ্যুয়ালাইজেশনের জন্য একটি বহুল ব্যবহৃত জাভাস্ক্রিপ্ট লাইব্রেরি ব্যবহার করে। D3.js ট্রানজিশন, ইন্টারপোলেশন এবং ইজিং ফাংশন সহ অ্যানিমেটিং উপাদানগুলির জন্য বৈশিষ্ট্যগুলির একটি সমৃদ্ধ সেট সরবরাহ করে, যা রিঅ্যাক্ট মুভকে অ্যানিমেশনগুলির একটি সমৃদ্ধ সেট অফার করতে দেয়</li>
                                            <li className='text-justify mb-3'>⦿ অবস্থানগত অ্যানিমেশন, রঙ পরিবর্তন এবং আরও অনেক কিছু সহ অ্যানিমেশন বিকল্পগুলির একটি বিস্তৃত পরিসর অফার করে৷ এটি আপনাকে সহজে জটিল অ্যানিমেশন তৈরি করতে দেয়</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://react-move-docs.netlify.app/" target='blank'>https://react-move-docs.netlify.app/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/sghall/react-move" target='blank'>https://github.com/sghall/react-move</a> </li>
                                        </ul>
                                    </>
                            }
                        </div>



                        {/* 4th Animation Package */}
                        <div>
                            {
                                language === 'english' ?
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>4. Remotion</h1>
                                    :
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>4. Remotion (রিমোশন)</h1>
                            }

                            {
                                language === 'english' ?
                                    <>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>With Remotion, you can create videos as well as play and review them on your browser while using React components and compositions. Remotion also allows developers to scale video animation and production using server-side rendering and parametrization. Parametrization is the process of finding equations of curves and surfaces using equations, which can be very useful in creating meshes for videos.  </p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>You can initialize a new Remotion video by running the commands below based on which package you are using:</p>
                                    </>
                                    :
                                    <>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>রিমোশনের সাহায্যে, আপনি ভিডিও তৈরি করতে পারেন এবং সেইসাথে আপনার ব্রাউজারে রিঅ্যাক্ট কম্পোনেন্ট এবং কম্পোজিশন ব্যবহার করে সেগুলি চালাতে ও পর্যালোচনা করতে পারেন। রিমোশন ডেভেলপারদের সার্ভার-সাইড রেন্ডারিং এবং প্যারামেট্রিাইজেশন ব্যবহার করে ভিডিও অ্যানিমেশন এবং উত্পাদন স্কেল করার অনুমতি দেয়। প্যারামেট্রিলাইজেশন হল সমীকরণ ব্যবহার করে বক্ররেখা এবং পৃষ্ঠতলের সমীকরণ খোঁজার প্রক্রিয়া, যা ভিডিওর জন্য জাল তৈরি করতে খুব কার্যকর হতে পারে। </p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>আপনি কোন প্যাকেজটি ব্যবহার করছেন তার উপর ভিত্তি করে নীচের কমান্ডগুলি চালিয়ে আপনি একটি নতুন রিমোশন ভিডিও শুরু করতে পারেন:</p>
                                    </>
                            }


                            <p className='mt-5 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>npm init video</p>
                            <p className='mt-4 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>yarn create video</p>
                            {
                                language === 'english' ?
                                    <>
                                        <p className='mt-4 text-black text-[17px]'>A video is a function of images over time. If you change content every frame, you’ll end up with an animation. To create one using Remotion, add the following lines of code:</p>
                                    </>
                                    :
                                    <p className='mt-4 text-black text-[17px]'>ভিডিও হচ্ছে সময়ের সাথে সাথে ছবির একটি ফাংশন। আপনি যদি প্রতিটি ফ্রেমের বিষয়বস্তু পরিবর্তন করেন, তাহলে আপনি একটি অ্যানিমেশন দিয়ে শেষ করবেন। রিমোশন ব্যবহার করে একটি তৈরি করতে, কোডের নিম্নলিখিত লাইনগুলি যোগ করুন:</p>
                            }

                            <div className='mt-8 '>
                                <div className='rounded-lg shadow-lg relative'>

                                    <button
                                        onClick={handleCopyClick4}
                                        className="absolute top-3 right-2 px-3 py-1 bg-gray-700 hover:bg-gray-600 text-white rounded cursor-pointer"
                                    >
                                        {copySuccess4 ? 'Copied!' : 'Copy'}
                                    </button>

                                    <SyntaxHighlighter language="javascript" style={sunburst}>
                                        {codeString4}
                                    </SyntaxHighlighter>
                                </div>
                            </div>

                            {
                                language === 'english' ?
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>Remotion Advantages</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ Programmatically generating video frames with React components provides more control and flexibility over video content creation</li>
                                            <li className='text-justify mb-3'>⦿ With the power of React and CSS, Remotion allows for complex animations and visual effects, enabling developers to create engaging video content</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://www.remotion.dev/" target='blank'>https://www.remotion.dev/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/remotion-dev/remotion" target='blank'>https://github.com/remotion-dev/remotion</a> </li>
                                        </ul>
                                    </>
                                    :
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>রিমোশনের সুবিধা</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ React component গুলির সাথে প্রোগ্রাম্যাটিকভাবে ভিডিও ফ্রেম তৈরি করা ভিডিও সামগ্রী তৈরিতে আরও নিয়ন্ত্রণ এবং নমনীয়তা প্রদান করে</li>
                                            <li className='text-justify mb-3'>⦿ রিঅ্যাক্ট এবং CSS এর শক্তির সাহায্যে, রিমোশন জটিল অ্যানিমেশন এবং ভিজ্যুয়াল ইফেক্টের জন্য অনুমতি দেয়, যা ডেভেলপারদের আকর্ষণীয় ভিডিও সামগ্রী তৈরি করতে সক্ষম করে</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://www.remotion.dev/" target='blank'>https://www.remotion.dev/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/remotion-dev/remotion" target='blank'>https://github.com/remotion-dev/remotion</a> </li>
                                        </ul>
                                    </>
                            }

                        </div>



                        {/* 5th Animation Package */}
                        <div>

                            {
                                language === 'english' ?
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>5. React Reveal</h1>
                                    :
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>5. React Reveal (রিঅ্যাক্ট রিভিল)</h1>
                            }

                            {
                                language === 'english' ?
                                    <>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>React Reveal is a high-performance and easy-to-use library for adding animations to React applications. Unlike most animation libraries, React Reveal only reveals animations and effects if you scroll down to the animated element, not during load time. This improves page speed by allowing animation components to be lazy-loaded.</p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>You can install React Reveal with the command below based on which package you are using:</p>
                                        <p className='mt-5 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>npm install react-reveal</p>
                                        <p className='mt-4 text-black text-[17px]'>To create a cool yet simple animation, add the following lines of code:</p>
                                    </>
                                    :
                                    <>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>রিঅ্যাক্ট রিভিল হল রিঅ্যাক্ট অ্যাপ্লিকেশানগুলিতে অ্যানিমেশন যুক্ত করার জন্য একটি উচ্চ-পারফরম্যান্স এবং সহজেই ব্যবহারযোগ্য লাইব্রেরি। বেশিরভাগ অ্যানিমেশন লাইব্রেরির বিপরীতে, রিঅ্যাক্ট রিভিল শুধুমাত্র অ্যানিমেশন এবং প্রভাব প্রকাশ করে যদি আপনি অ্যানিমেটেড উপাদানে স্ক্রোল করেন, লোডের সময় নয়। এটি অ্যানিমেশন উপাদানগুলিকে অলস-লোড করার অনুমতি দিয়ে পৃষ্ঠার গতি উন্নত করে।</p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>আপনি কোন প্যাকেজটি ব্যবহার করছেন তার উপর ভিত্তি করে আপনি নীচের কমান্ডের সাথে প্রতিক্রিয়া প্রকাশ ইনস্টল করতে পারেন:</p>
                                        <p className='mt-5 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>npm install react-reveal</p>
                                        <p className='mt-4 text-black text-[17px]'>একটি দুর্দান্ত তবে সহজ অ্যানিমেশন তৈরি করতে, কোডের নিম্নলিখিত লাইনগুলি যুক্ত করুন:</p>
                                    </>
                            }


                            <div className='mt-8 '>
                                <div className='rounded-lg shadow-lg relative'>
                                    <button
                                        onClick={handleCopyClick5}
                                        className="absolute top-3 right-2 px-3 py-1 bg-gray-700 hover:bg-gray-600 text-white rounded cursor-pointer"
                                    >
                                        {copySuccess5 ? 'Copied!' : 'Copy'}
                                    </button>
                                    <SyntaxHighlighter language="javascript" style={sunburst}>
                                        {codeString5}
                                    </SyntaxHighlighter>
                                </div>
                            </div>

                            {
                                language === 'english' ?
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>React Reveal Advantages</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ Provides a straightforward and easy-to-use API for adding animations to React components. Developers can quickly apply animations without writing complex CSS or JavaScript code</li>
                                            <li className='text-justify mb-3'>⦿ Offers a wide range of built-in animations, such as fade, slide, zoom, rotate, shake, bounce, and more. These animations can be easily applied with minimal effort</li>
                                            <li className='text-justify mb-3'>⦿ Designed to be performant, and it includes features like lazy loading and smooth animations to ensure a smooth user experience</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://www.react-reveal.com/" target='blank'>https://www.react-reveal.com/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/rnosov/react-reveal" target='blank'>https://github.com/rnosov/react-reveal</a> </li>
                                        </ul>
                                    </>
                                    :
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>রিঅ্যাক্ট রিভিল এর সুবিধা</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ React component গুলিতে অ্যানিমেশন যোগ করার জন্য একটি সহজবোধ্য এবং সহজেই ব্যবহারযোগ্য API প্রদান করে। বিকাশকারীরা জটিল CSS বা জাভাস্ক্রিপ্ট কোড না লিখে দ্রুত অ্যানিমেশন প্রয়োগ করতে পারে</li>
                                            <li className='text-justify mb-3'>⦿ বিল্ট-ইন অ্যানিমেশনের বিস্তৃত পরিসর অফার করে, যেমন ফেইড, স্লাইড, জুম, ঘোরানো, ঝাঁকান, বাউন্স এবং আরও অনেক কিছু। এই অ্যানিমেশনগুলি ন্যূনতম প্রচেষ্টায় সহজেই প্রয়োগ করা যেতে পারে</li>
                                            <li className='text-justify mb-3'>⦿ পারফরম্যান্সের জন্য ডিজাইন করা হয়েছে এবং এতে ব্যবহারকারীর মসৃণ অভিজ্ঞতা নিশ্চিত করতে অলস লোডিং এবং মসৃণ অ্যানিমেশনের মতো বৈশিষ্ট্য রয়েছে</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://www.react-reveal.com/" target='blank'>https://www.react-reveal.com/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/rnosov/react-reveal" target='blank'>https://github.com/rnosov/react-reveal</a> </li>
                                        </ul>
                                    </>
                            }


                        </div>



                        {/* 6th Animation Package */}
                        <div>

                            {
                                language === 'english' ?
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>6. Anime.js</h1>
                                    :
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>6. Anime.js (এনিমে.জেএস)</h1>
                            }

                            {
                                language === 'english' ?
                                    <>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>Anime.js is a lightweight JavaScript animation library with a simple, yet powerful API. It makes animating CSS properties, SVG elements, DOM attributes, and JavaScript objects a breeze.</p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>To install Anime.js, run one of the following commands below based on which package you are using:</p>
                                    </>
                                    :
                                    <>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>Anime.js হল একটি হালকা জাভাস্ক্রিপ্ট অ্যানিমেশন লাইব্রেরি যার একটি সহজ, কিন্তু শক্তিশালী API। এটি অ্যানিমেটিং CSS বৈশিষ্ট্য, SVG উপাদান, DOM বৈশিষ্ট্য এবং জাভাস্ক্রিপ্ট অবজেক্টকে একটি হাওয়ায় পরিণত করে।</p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>Anime.js ইনস্টল করতে, আপনি কোন প্যাকেজ ব্যবহার করছেন তার উপর ভিত্তি করে নীচের নিম্নলিখিত কমান্ডগুলির মধ্যে একটি চালান:</p>
                                    </>
                            }

                            <p className='mt-5 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>npm install animejs</p>
                            <p className='mt-5 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>yarn add animejs</p>


                            {
                                language === 'english' ?
                                    <p className='mt-4 text-black text-[17px]'>To create a cool SVG animation, add the lines of code below:</p>
                                    :
                                    <p className='mt-4 text-black text-[17px]'>একটি দুর্দান্ত SVG অ্যানিমেশন তৈরি করতে, নীচের কোডের লাইনগুলি যোগ করুন:</p>
                            }


                            <div className='mt-8 '>
                                <div className='rounded-lg shadow-lg relative'>
                                    <button
                                        onClick={handleCopyClick6}
                                        className="absolute top-3 right-2 px-3 py-1 bg-gray-700 hover:bg-gray-600 text-white rounded cursor-pointer"
                                    >
                                        {copySuccess6 ? 'Copied!' : 'Copy'}
                                    </button>
                                    <SyntaxHighlighter language="javascript" style={sunburst}>
                                        {codeString6}
                                    </SyntaxHighlighter>
                                </div>
                            </div>

                            {
                                language === 'english' ?
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>Anime.js Advantages</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ This library supports a wide range of animations, including simple property animations like opacity, scale, and rotation, as well as more complex animations such as motion paths and sequences</li>
                                            <li className='text-justify mb-3'>⦿ Provides a variety of easing functions that allow developers to control the animation’s acceleration and deceleration, resulting in smooth and natural transitions</li>
                                            <li className='text-justify mb-3'>⦿ Allows the creation of animation timelines, enabling the precise orchestration of multiple animations, delays, and sequencing for more synchronized effects</li>
                                            <li className='text-justify mb-3'>⦿ Seamlessly animates SVG elements and attributes, making it an excellent choice for creating interactive and dynamic SVG-based graphics</li>
                                            <li className='text-justify mb-3'>⦿ Anime.js can chain multiple animations together or attach callbacks to specific animation events, offering greater control over the animation flow</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://animejs.com/" target='blank'>https://animejs.com/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/juliangarnier/anime" target='blank'>https://github.com/juliangarnier/anime</a> </li>
                                        </ul>
                                    </>
                                    :
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>Anime.js এর সুবিধা</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ এই লাইব্রেরিটি অ্যানিমেশনের একটি বিস্তৃত পরিসরকে সমর্থন করে, যার মধ্যে রয়েছে অস্বচ্ছতা, স্কেল এবং ঘূর্ণনের মতো সাধারণ সম্পত্তি অ্যানিমেশন, সেইসাথে মোশন পাথ এবং সিকোয়েন্সের মতো আরও জটিল অ্যানিমেশন</li>
                                            <li className='text-justify mb-3'>⦿ বিভিন্ন ধরনের ইজিং ফাংশন প্রদান করে যা ডেভেলপারদের অ্যানিমেশনের ত্বরণ এবং হ্রাস নিয়ন্ত্রণ করতে দেয়, যার ফলে মসৃণ এবং প্রাকৃতিক রূপান্তর হয়</li>
                                            <li className='text-justify mb-3'>⦿ অ্যানিমেশন টাইমলাইন তৈরির অনুমতি দেয়, একাধিক অ্যানিমেশনের সুনির্দিষ্ট অর্কেস্ট্রেশন, বিলম্ব এবং আরও সিঙ্ক্রোনাইজড প্রভাবের জন্য সিকোয়েন্সিং সক্ষম করে</li>
                                            <li className='text-justify mb-3'>⦿ নির্বিঘ্নে SVG উপাদান এবং বৈশিষ্ট্যগুলিকে অ্যানিমেট করে, এটি ইন্টারেক্টিভ এবং গতিশীল SVG-ভিত্তিক গ্রাফিক্স তৈরির জন্য একটি চমৎকার পছন্দ করে তোলে</li>
                                            <li className='text-justify mb-3'>⦿ Anime.js একাধিক অ্যানিমেশন একসাথে চেইন করতে পারে বা নির্দিষ্ট অ্যানিমেশন ইভেন্টগুলিতে কলব্যাক সংযুক্ত করতে পারে, অ্যানিমেশন প্রবাহের উপর আরও বেশি নিয়ন্ত্রণ প্রদান করে</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://animejs.com/" target='blank'>https://animejs.com/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/juliangarnier/anime" target='blank'>https://github.com/juliangarnier/anime</a> </li>
                                        </ul>
                                    </>
                            }


                        </div>



                        {/* 7th Animation Package */}
                        <div>
                            {
                                language === 'english' ?
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>7. GreenSock (GSAP)</h1>
                                    :
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>7. GreenSock (GSAP) (গ্রীনসক (জিএসএপি))</h1>
                            }

                            {
                                language === 'english' ?
                                    <>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>GSAP (GreenSock Animation Platform) is a robust and widely-used animation library for creating high-performance animations and interactive web experiences. It has been a popular choice among developers for many years. Known for its speed, flexibility, and smoothness, GSAP empowers developers to craft seamless animations with ease.</p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>You can install GSAP with one of the commands below based on which package you are using:</p>
                                    </>
                                    :
                                    <>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>GSAP (GreenSock Animation Platform) হল একটি শক্তিশালী এবং বহুল ব্যবহৃত অ্যানিমেশন লাইব্রেরি যা উচ্চ-ক্ষমতাসম্পন্ন অ্যানিমেশন এবং ইন্টারেক্টিভ ওয়েব অভিজ্ঞতা তৈরির জন্য। এটি বহু বছর ধরে বিকাশকারীদের মধ্যে একটি জনপ্রিয় পছন্দ হয়েছে। গতি, নমনীয়তা এবং মসৃণতার জন্য পরিচিত, GSAP ডেভেলপারদের সহজে নির্বিঘ্ন অ্যানিমেশন তৈরি করার ক্ষমতা দেয়।</p>
                                        <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>আপনি কোন প্যাকেজটি ব্যবহার করছেন তার উপর ভিত্তি করে নীচের একটি কমান্ড দিয়ে আপনি GSAP ইনস্টল করতে পারেন:</p>
                                    </>
                            }



                            <p className='mt-5 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>npm install gsap</p>
                            <p className='mt-5 text-justify px-4 text-black  text-[17px] bg-gray-300 py-2'>yarn add gsap</p>
                            {
                                language === 'english' ?
                                    <p className='mt-4 text-black text-[17px]'>To create a cool scroll triggered animation, add the following code:</p>
                                    :
                                    <p className='mt-4 text-black text-[17px]'>একটি দুর্দান্ত স্ক্রোল-ট্রিগার অ্যানিমেশন তৈরি করতে, নিম্নলিখিত কোড যোগ করুন:</p>
                            }
                            <div className='mt-8 '>
                                <div className='rounded-lg shadow-lg relative'>
                                    <button
                                        onClick={handleCopyClick7}
                                        className="absolute top-3 right-2 px-3 py-1 bg-gray-700 hover:bg-gray-600 text-white rounded cursor-pointer"
                                    >
                                        {copySuccess7 ? 'Copied!' : 'Copy'}
                                    </button>
                                    <SyntaxHighlighter language="javascript" style={sunburst}>
                                        {codeString7}
                                    </SyntaxHighlighter>
                                </div>
                            </div>

                            {
                                language === 'english' ?
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>GSAP Advantages</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ Provides a powerful and flexible animation engine capable of handling complex animations with ease. It supports a wide range of properties, CSS attributes, SVG, and more</li>
                                            <li className='text-justify mb-3'>⦿ Works consistently across different browsers, including older versions. Its plugin architecture allows easy integration of additional features and enhances its capabilities, such as scroll animations (ScrollTrigger) and physics-based animations (Physics2D)</li>
                                            <li className='text-justify mb-3'>⦿ Allows precise control over multiple animations, enabling synchronized and choreographed animations</li>
                                            <li className='text-justify mb-3'>⦿ Offers comprehensive documentation with clear examples, making it easy for developers to understand and implement its features</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://gsap.com/" target='blank'>https://gsap.com/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/greensock/GSAP" target='blank'>https://github.com/greensock/GSAP</a> </li>
                                        </ul>
                                    </>
                                    :
                                    <>
                                        <h1 className='mt-12 mb-4 text-2xl text-start text-black font-bold'>GSAP এর সুবিধা</h1>
                                        <ul className='text-black text-justify text-lg'>
                                            <li className='text-justify mb-3'>⦿ সহজে জটিল অ্যানিমেশন পরিচালনা করতে সক্ষম একটি শক্তিশালী এবং নমনীয় অ্যানিমেশন ইঞ্জিন প্রদান করে। এটি বিস্তৃত বৈশিষ্ট্য, CSS বৈশিষ্ট্য, SVG এবং আরও অনেক কিছু সমর্থন করে</li>
                                            <li className='text-justify mb-3'>⦿ পুরানো সংস্করণ সহ বিভিন্ন ব্রাউজারে ধারাবাহিকভাবে কাজ করে। এর প্লাগইন আর্কিটেকচার অতিরিক্ত বৈশিষ্ট্যগুলির সহজে একীকরণের অনুমতি দেয় এবং এর ক্ষমতা বাড়ায়, যেমন স্ক্রোল অ্যানিমেশন (স্ক্রোলট্রিগার) এবং পদার্থবিদ্যা-ভিত্তিক অ্যানিমেশন (ফিজিক্স 2ডি)</li>
                                            <li className='text-justify mb-3'>⦿ সিঙ্ক্রোনাইজড এবং কোরিওগ্রাফড অ্যানিমেশন সক্ষম করে একাধিক অ্যানিমেশনের উপর সুনির্দিষ্ট নিয়ন্ত্রণের অনুমতি দেয়</li>
                                            <li className='text-justify mb-3'>⦿ স্পষ্ট উদাহরণ সহ ব্যাপক ডকুমেন্টেশন অফার করে, যা ডেভেলপারদের জন্য এর বৈশিষ্ট্যগুলি বুঝতে এবং বাস্তবায়ন করা সহজ করে তোলে</li>
                                            <li className='mt-3 md:text-justify text-start'>⦿ Website: <a className='text-blue-700' href="https://gsap.com/" target='blank'>https://gsap.com/</a> </li>
                                            <li className='md:text-justify text-start mt-3'>⦿ GitHub: <a className='text-blue-700' href="https://github.com/greensock/GSAP" target='blank'>https://github.com/greensock/GSAP</a> </li>
                                        </ul>
                                    </>
                            }


                        </div>



                        <ReactPrint trigger={() => <button className='print:hidden ml-1 hover:scale-105 mt-28 mb-16 px-6 py-2 bg-green-600 text-white'>
                            <div className='text-[16px] text-white flex justify-start items-center gap-x-1'>
                                <BsFileEarmarkPdf size={25} className='text-white'></BsFileEarmarkPdf>
                                {
                                    language === 'english' ?
                                        <p>Download PDF</p>
                                        :
                                        <p>ডাউনলোড পিডিএফ</p>
                                }
                            </div>
                        </button>} content={() => ref.current}>

                        </ReactPrint>



                    </div>

                    {
                        language === 'english' ?
                            <h1 className=' print:hidden mt-20 lg:mb-3 mb-3 md:text-2xl text-2xl text-start text-black font-bold'>Share This Post</h1>
                            :
                            <h1 className=' print:hidden mt-20 lg:mb-3 mb-3 md:text-2xl text-2xl text-start text-black font-bold'>পোস্টটি শেয়ার করুন</h1>
                    }
                    <div className='print:hidden flex justify-start items-center'>
                        <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Facebook'>
                            <FacebookShareButton
                                url={shareUrl}
                                quote={'Share Blog on Facebook'}
                                hashtag={'#blog'}
                                style={{ marginRight: '7px' }}
                            >
                                <FacebookIcon size={38} round={true} />
                            </FacebookShareButton>
                        </div>
                        <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Twitter'>
                            <TwitterShareButton
                                url={shareUrl}
                                quote={'Share Blog on Twitter'}
                                hashtag={'#blog'}
                                style={{ marginRight: '7px' }}
                            >
                                <TwitterIcon size={38} round={true} />
                            </TwitterShareButton>
                        </div>
                        <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on LinkedIn'>
                            <LinkedinShareButton
                                url={shareUrl}
                                quote={'Share Blog on LinkedIn'}
                                hashtag={'#blog'}
                                style={{ marginRight: '7px' }}
                            >
                                <LinkedinIcon size={38} round={true} />
                            </LinkedinShareButton>
                        </div>
                        <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on WhatsApp'>
                            <WhatsappShareButton
                                url={shareUrl}
                                quote={'Share Blog on WhatsApp'}
                                hashtag={'#blog'}
                                style={{ marginRight: '7px' }}
                            >
                                <WhatsappIcon size={38} round={true} />
                            </WhatsappShareButton>
                        </div>
                    </div>






                </div>


                <div className='print:hidden lg:w-3/12 w-full mx-auto lg:px-6 px-1'>
                    <div className='lg:right-auto lg:fixed lg:top-[160px] lg:mr-10 relative'>
                        <div className={`bg-gray-700 rounded-sm px-3 pt-2 pb-3 `}>
                            <p className='text-white text-center text-lg -mt-1 px-6 py-1'>Read More Blogs... </p>

                            <div>


                                <Link to='/blog7'>
                                    <div className='mx-auto hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group ' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={resume} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='md:text-lg lg:text-[16px] text-md text-yellow-400 group-hover:text-white'>How To Improve Your Resume In 9 Steps</p>
                                    </div>
                                </Link>


                                <Link to='/blog2'>
                                    <div className='mx-auto hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={npm1} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='md:text-lg lg:text-[16px] text-md text-yellow-400 group-hover:text-white'>Worst npm Packages you should not use</p>
                                    </div>
                                </Link>

                                <Link to='/blog3'>
                                    <div className='hover:border-blue-500 mx-auto cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={studyAbroad} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white md:text-lg lg:text-[16px]  text-md'>Why Study Abroad? Stories From Students</p>
                                    </div>
                                </Link>
                                <Link to='/blog4'>
                                    <div className=' hover:border-blue-500 mx-auto cursor-pointer gap-x-3  mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={visa} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white md:text-lg lg:text-[16px]  text-md '>EveryThing You Should Know about Student Visa</p>
                                    </div>
                                </Link>




                                {/* <div className=' -mt-12 lg:w-[300px] md:mediumWidth smallWidth  mx-auto'>
                                    <Swiper
                                        pagination={{
                                            clickable: true
                                        }}
                                        modules={[Pagination, Autoplay, Navigation]}
                                        autoplay={{ delay: 2000 }}
                                        className="mySwiper"
                                    >

                                        <SwiperSlide className=''>
                                            <div>
                                                <Link to='/blog3'>
                                                    <div className='hover:border-blue-500 lg:w-[300px] md:mediumWidth smallWidth  mx-auto cursor-pointer gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={studyAbroad} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md'>Why Study Abroad? Stories From International Students</p>
                                                    </div>
                                                </Link>
                                                <Link to='/blog4'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:mediumWidth smallWidth  mx-auto cursor-pointer gap-x-3  mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={visa} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>EveryThing You Should Know about Student Visa</p>
                                                    </div>
                                                </Link>
                                            </div>
                                        </SwiperSlide>


                                        <SwiperSlide className=''>
                                            <div>

                                                <Link to='/blog5'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:mediumWidth smallWidth  mx-auto cursor-pointer gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={program} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>4 Reasons Why Year Gap In Study Isn't End of life</p>
                                                    </div>
                                                </Link>

                                                <Link to='/blog7'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:mediumWidth smallWidth  mx-auto cursor-pointer gap-x-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={resume} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>How To Improve Your Resume In 9 Steps</p>
                                                    </div>
                                                </Link>
                                            </div>
                                        </SwiperSlide>

                                    </Swiper>
                                </div> */}


                            </div>




                        </div>
                    </div>
                </div>




            </div>


        </div >
    );
};

export default Blog1Details;